import styled, { css, keyframes } from 'styled-components'
import { colors, device } from '../../../styles/GlobalVariables'

const loader = keyframes`
  0% {
    background-color: black;
  }
  100% {
    background-color: ${colors.tvGuideDark};
  }
`

export const RailItemWrap = styled.div`
  cursor: pointer;
  color: white;

  &.first {
    transform-origin: right;
  }

  &.last {
    transform-origin: left;
  }

  a {
    text-decoration: none;
  }
`
export const RailItemImageWrap = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: calc(100% * 1.77);
  cursor: pointer;
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 9px 9px rgba(0, 0, 0, 0.4);
  transition: all 0.6s ease;

  ${device.small} {
    border-radius: 0.8125rem;

    &:hover {
      opacity: 1;
      transform: scale(1.04);

      &:after {
        opacity: 1;
      }
    }
  }

  ${props =>
    !props.theme.found
      ? css`
          background: linear-gradient(
            90deg,
            #06060d -34.07%,
            #171f3d 47.01%,
            #06060d 137.67%
          );

          img {
            width: 45%;
            height: auto !important;
          }
        `
      : ''}
`

export const RailItemImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 24.5rem;

  ${props =>
    !props.theme.loaded &&
    css`
      animation: ${loader} 1s linear infinite;
    `}
  &:after {
    content: '';
    opacity: 0;
    transition: opacity 0.2s ease;
    position: absolute;
    bottom: 0.625rem;
    right: 0.625rem;
    width: 1.25rem;
    height: 1.25rem;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg fill='white' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2rem' height='2rem' viewBox='0 0 163.861 163.861' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275 c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z'/%3E%3C/g%3E%3C/svg%3E");
    z-index: 1;
  }
`

export const ProgramNameTitle = styled.div`
  color: #fff;
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.4px;
  margin-top: 10px;

  ${device.small} {
    font-size: 23px;
    letter-spacing: -0.46px;
    ${props =>
      props.theme.compName === 'full_poster'
        ? css`
            margin-top: 12px;
          `
        : ''}
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }
`
